import { React, useState } from 'react';
import style from './../adminSect.module.scss';
import DisplayStands from '../../utils/DisplayStands';
import { CustomSideModalStands } from '../../utils/Modals';
import './stands.scss';

const Stands = ({ hallStands, setHallStands, hall, hallState }) => {
  const { hallContainer } = style;

  const [showSideBar, setShowSideBar] = useState(false);
  const [standData, setStandData] = useState({});
  const [standPage, setStandPage] = useState(1);

  const handleShowModal = (data) => {
    setShowSideBar(true);
    setStandData(data);
  };

  return (
    <>
      <div id="imgContainer" className={hallContainer}>
        <DisplayStands
          handleShowModal={handleShowModal}
          occupedStands={hallStands.length !== 0 ? hallStands : []}
          hall={hall}
          standPage={standPage}
          setStandPage={setStandPage}
          hallState={hallState}
        />
      </div>
      <CustomSideModalStands
        setHallStands={setHallStands}
        hall={hall}
        showSideBar={showSideBar}
        setShowSideBar={setShowSideBar}
        stand={standData}
      />
    </>
  );
};

export default Stands;
